const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    loop: true,
    speed: 600, // 少しゆっくり(デフォルトは300)
    effect: 'slide',
    slidesPerView: 1,
    loopedSlides: 2,
    spaceBetween: 10,
    centeredSlides: true,
  
    breakpoints: {
    // スライドの表示枚数：780px以上の場合
    780: {
      slidesPerView: 1.3,
    },
    1300: {
      slidesPerView: 2.2,
    },
  },

  autoplay: { // 自動再生
    delay: 4500, // 3000→3秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
	  type: 'bullets',
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });